import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { VisbilitySettingsFragmentDoc } from '../../../../Form/components/VisibilitySettings/graphql/fragment/generated/VisibilitySettings';
export type NavConfigFragment = { children: Array<{ key: string, label: string, type: Types.NavbarElementTypeEnum, status?: Types.PageComponentStatusEnum | null, collectionIds?: Array<string> | null, icon?: string | null, order?: number | null, systemGenerated?: boolean | null, props?: string | null, visibilitySettings?: { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null } | null, children?: Array<{ key: string, label: string, type: Types.NavbarElementTypeEnum, icon?: string | null, description?: string | null, props?: string | null, status?: Types.PageComponentStatusEnum | null, order?: number | null, visibilitySettings?: { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null } | null, localizedDescriptionConfigs?: Array<{ languageType: string, value: string }> | null, localizedLabelConfigs?: Array<{ languageType: string, value: string }> | null }> | null, localizedLabelConfigs?: Array<{ languageType: string, value: string }> | null }> };


export type NavConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const NavConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment NavConfig on NavConfigProperties {
  children {
    key
    label
    type
    status
    collectionIds
    icon
    order
    systemGenerated
    visibilitySettings {
      ...VisbilitySettings
    }
    children {
      key
      label
      type
      icon
      description
      props
      status
      order
      visibilitySettings {
        ...VisbilitySettings
      }
      localizedDescriptionConfigs {
        languageType
        value
      }
      localizedLabelConfigs {
        languageType
        value
      }
    }
    localizedLabelConfigs {
      languageType
      value
    }
    props
  }
}
    `;